import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { submitApplicationApproveDocuments } from '../service'

export const useSubmitApproveDocuments: WriteHook<{ id: number }, void> = (opts) =>
  useMutationManager(submitApplicationApproveDocuments, opts)
